// services/updateLinkTime.js
import instance from "../../utils/axios";

export const updateLinkTime = async ({ code, link_time }) => {
  try {
    const response = instance.post(`/update-link-time`, {
      code,
      link_time,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to update link time", error);
    return null;
  }
};
